import React from 'react';

export const LoaderSpinner: React.FC = () => {
  return (
    <div className="relative flex flex-col items-center">
      <div className="relative w-24 h-24">
        <div className="absolute inset-0 rounded-full border-t-2 border-rs-bright animate-spin"></div>
        <div className="absolute inset-2 rounded-full border-r-2 border-rs-dark animate-spin-reverse"></div>
        <div className="absolute inset-0 flex items-center justify-center">
          <div className="w-2 h-2 bg-rs-bright rounded-full animate-ping"></div>
        </div>
      </div>
    </div>
  );
};
